import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';
import {Notificacao} from "@core/models/notificacoes";
import {PageResponse} from "@core/models/page-response";
import {PageableParams} from "@core/models/pageable-params";
import {environment} from "@environments/environment";
import {Observable} from "rxjs";

export interface NotificacaoResumo {
  total: number;
  valorTotal: number;
  emAnalise: number;
  valorEmAnalise: number;
  tap: number;
  valorTap: number;
  arbitral: number;
  valorArbitral: number;
  acolhida: number;
  valorAcolhida: number;
  anuladaCancelada: number;
  valorAnuladaCancelada: number;
}

export interface NotificacaoHistorico {
  tipoEvento: 'CRIACAO' | 'ALTERACAO';
  campo: string | null;
  valorAnterior: string | null;
  valorNovo: string | null;
  usuario: string;
  dataEvento: string;
}

export interface OpcoesFiltroNotificacao {
  superintendencia: string[];
  diretoria: string[];
  motivo: string[];
  status: string[];
  fase: string[];
  curso: string[];
  grupo: string[];
  nivel: string[];
  tipoTap: string[];
  situacaoTap: string[];
  concessionaria: string[];
}

export interface NotificacaoLoteRequest {
  ids: number[];
  status?: { id: number; nome: string } | null;
  fase?: { id: number; nome: string } | null;
  curso?: { id: number; nome: string } | null;
  motivo?: { id: number; nome: string } | null;
  superintendencia?: { id: number; nome: string } | null;
  diretoria?: { id: number; nome: string } | null;
  concessionaria?: { id: number; nome: string } | null;
  grupo?: { id: number; nome: string } | null;
  nivel?: { id: number; nome: string } | null;
  tipoTap?: { id: number; nome: string } | null;
  situacaoTap?: { id: number; nome: string } | null;
  andamento?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class NotificacaoService {
  private uri = environment.api.uri.concat('notificacao')
  private http = inject(HttpClient)

  get(payload: PageableParams): Observable<PageResponse<Notificacao>> {
    const params = payload.toQueryString();
    return this.http.get<PageResponse<Notificacao>>(`${this.uri}?${params}`);
  }

  put(id: number, payload: Notificacao): Observable<any> {
    return this.http.put<any>(`${this.uri}/${id}`, payload);
  }

  create(payload: Notificacao): Observable<any> {
    return this.http.post<any>(this.uri, payload);
  }

  getById(id: number): Observable<Notificacao> {
    return this.http.get<Notificacao>(`${this.uri}/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.uri}/${id}`);
  }

  getResumo(filterQueryString = ''): Observable<NotificacaoResumo> {
    const query = filterQueryString ? `?${filterQueryString}` : '';
    return this.http.get<NotificacaoResumo>(`${this.uri}/resumo${query}`);
  }

  atualizarLote(dto: NotificacaoLoteRequest): Observable<void> {
    return this.http.patch<void>(`${this.uri}/lote`, dto);
  }

  getHistorico(id: number): Observable<NotificacaoHistorico[]> {
    return this.http.get<NotificacaoHistorico[]>(`${this.uri}/${id}/historico`);
  }

  /** Valores disponíveis pra cada filtro (filtro em cascata), dados os outros filtros
   * já ativos — cada campo da resposta ignora o filtro do próprio campo. */
  getOpcoesFiltro(filterQueryString = ''): Observable<OpcoesFiltroNotificacao> {
    const query = filterQueryString ? `?${filterQueryString}` : '';
    return this.http.get<OpcoesFiltroNotificacao>(`${this.uri}/opcoes-filtro${query}`);
  }

}
